import moment from 'moment'

export const dayStart = moment =>
    moment
        .hour(0)
        .minute(0)
        .seconds(0)
        .millisecond(0)
export const dayEnd = moment =>
    moment
        .hour(23)
        .minute(59)
        .seconds(59)
        .millisecond(999)
export const earlierDate = (m1, m2) => (m1.isAfter(m2) ? m2 : m1)
